import { href, type Route } from '../app/useHashRoute.js';
import { LeaderboardPanel } from '../components/LeaderboardPanel.js';
import { LegalLinks } from '../legal/LegalLinks.js';

const items: { route: Route; title: string; blurb: string; icon: string }[] = [
  {
    route: 'play',
    title: 'Play',
    blurb: 'Find a match or host a table',
    icon: '🚨',
  },
  {
    route: 'tutorial',
    title: 'Tutorial',
    blurb: 'Learn the game in three steps',
    icon: '📖',
  },
  { route: 'cast', title: 'The cast', blurb: 'Meet every character', icon: '🎭' },
  {
    route: 'settings',
    title: 'Settings',
    blurb: 'Sound, motion and account',
    icon: '⚙',
  },
];

export function MenuScreen() {
  return (
    <div className="page stack">
      <h1 className="screen-title">Situation Room</h1>
      <p className="muted-on-dark">
        Start or join a match, learn how to play, meet the cast, or change your settings.
      </p>
      <ul className="menu-grid" role="list">
        {items.map((item) => (
          <li key={item.route}>
            <a className="menu-tile" href={href(item.route)}>
              <span className="menu-tile__icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="menu-tile__title">{item.title}</span>
              <span className="menu-tile__blurb">{item.blurb}</span>
            </a>
          </li>
        ))}
      </ul>
      <LeaderboardPanel limit={10} />
      <LegalLinks />
    </div>
  );
}
